import IConfiguration from "./IConfiguration"
export default interface IBetConfig extends IConfiguration {
    /**
     * an array of bets that the client wants to be visualized
     */
    betOptions: number[];
    /**
     * @returns: the bets from the configuration array that match the valid bets sent by the server or empty array
     */
    getBetOptions(): number[];

    primaryCurrencyType: CurrencyType;
    alternativeCurrencyType: CurrencyType;
}

export enum CurrencyType {
    None = 0,
    Money = 1,
    Coins = 2
}